"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _errorHelpers = require("../helpers/errorHelpers");
var _qfsAccessBase = require("./qfsAccessBase");
var _templateLocationTypes = require("./templateLocationTypes");
var _excluded = ["file", "fileName"],
  _excluded2 = ["error"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PARAM_TEMPLATE_NAME = 'templateName';
var PARAM_LIBRARY_URL = 'libraryUrl';
var PARAM_XSN_URL = 'xsnUrl';
function getTemplateQueryParam(accessType) {
  switch (accessType) {
    case _templateLocationTypes.LOCATION_TYPE_LIBRARY:
      return PARAM_LIBRARY_URL;
    case _templateLocationTypes.LOCATION_TYPE_XSN:
      return PARAM_XSN_URL;
    case _templateLocationTypes.LOCATION_TYPE_TEMPLATE_NAME:
    default:
      return PARAM_TEMPLATE_NAME;
  }
}
function qfsAccess(qfsAccessBase, templateLocation) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    locationType = _ref.locationType,
    location = _ref.location;
  var makeUrl = qfsAccessBase.makeUrl,
    callCrossDomainRequestAsync = qfsAccessBase.callCrossDomainRequestAsync,
    getTextAsync = qfsAccessBase.getTextAsync,
    getXmlAsync = qfsAccessBase.getXmlAsync,
    makeServiceGetRequestAsync = qfsAccessBase.makeServiceGetRequestAsync,
    makeServicePostRequestAsync = qfsAccessBase.makeServicePostRequestAsync,
    queryDirectSoapAsync = qfsAccessBase.queryDirectSoapAsync,
    serviceUrl = qfsAccessBase.serviceUrl,
    callHelperGet = qfsAccessBase.callHelperGet;
  var currentTemplateLocationType;
  var formQueryParam;
  var templateQueryParams;
  function setAccessType(newLocationType, newLocation) {
    if (!newLocation) {
      currentTemplateLocationType = null;
      formQueryParam = null;
      templateQueryParams = {};
      return;
    }
    currentTemplateLocationType = newLocationType;
    formQueryParam = getTemplateQueryParam(newLocationType);
    templateQueryParams = _defineProperty({}, formQueryParam, newLocation);
  }

  // initialize
  setAccessType(locationType || _templateLocationTypes.LOCATION_TYPE_TEMPLATE_NAME, templateLocation);

  // String, Object -> Promise[Any]
  // Makes a request to the specified QFS method with the indicated parameter values,
  // and returns a promise for the returned data
  function makeServiceGetRequestAsyncInternal(method, params, cache) {
    var allParams = _objectSpread(_objectSpread({}, templateQueryParams), params || {});
    return makeServiceGetRequestAsync(method, allParams, cache);
  }

  // 2018-06-27 - Removed unused getManifestAsync

  var getTemplateFileParams = function getTemplateFileParams(fileName, instanceId, templateName) {
    var params = {
      fileName: fileName
    };
    if (instanceId) {
      params.instanceId = instanceId;
    }
    // BUGBUG: the access type (xsn, library, template) should be indicated when
    // qfsAccess is instantiated and shouldn't need to be passed in here
    if (templateName) {
      params.templateName = templateName;
    }
    return _objectSpread(_objectSpread({}, templateQueryParams), params);
  };

  // String -> Promise[Any]
  // Makes a request for the specified template file and returns a promise for
  // the data object returned
  function getTemplateFileAsync(fileName, instanceId, templateName) {
    var params = getTemplateFileParams(fileName, instanceId, templateName);
    var cache = !!instanceId;
    return makeServiceGetRequestAsyncInternal('Forms/FormFileContents', params, cache);
  }

  // void -> String
  // Returns the string to be sent to preprocessed view requests to provide the image url prefix for
  // rendering images
  function getImagePrefix(instanceId) {
    var targetUrl = "".concat(serviceUrl, "Forms/TemplateFile");
    var instanceIdParam = instanceId ? {
      instanceId: instanceId
    } : null;
    var params = _objectSpread(_objectSpread({}, templateQueryParams), instanceIdParam);
    var useCache = 'instanceId' in params;

    // fileName must be at end of URL so that the name can be appended after that
    return "".concat(makeUrl(targetUrl, params, useCache), "&fileName=");
  }

  // String -> Promise[Any]
  // Makes a PreprocessedView request for the indicated view and returns a promise for the returned data
  function requestViewAsync(view, instanceId) {
    var params = {
        viewFileName: view,
        paramNames: 'ImagePrefix',
        paramValues: getImagePrefix(instanceId)
      },
      cache = !!instanceId;
    if (instanceId) {
      params.instanceId = instanceId;
    }
    return makeServiceGetRequestAsyncInternal('Forms/PreprocessedView', params, cache);
  }
  function querySoapAsync(serviceUri, methodName, soapAction, strBody, overrideAction, useCookie) {
    return makeServicePostRequestAsync('WebProxy/CallSoapService', {
      url: serviceUri,
      soapServiceAction: soapAction,
      data: strBody,
      overrideAction: !!overrideAction,
      useCookie: !!useCookie,
      Credentials: {
        User: '',
        Password: '',
        Domain: ''
      }
    });
  }

  // Method to create new guid.
  function newGuidAsync(format) {
    return makeServiceGetRequestAsync('FormsViewer/NewGuid', {
      format: format
    });
  }
  function getAccessType() {
    var _currentTemplateLocat;
    return (_currentTemplateLocat = currentTemplateLocationType) !== null && _currentTemplateLocat !== void 0 ? _currentTemplateLocat : null;
  }
  function getTemplateLocation() {
    var _templateQueryParams$;
    return (_templateQueryParams$ = templateQueryParams[formQueryParam]) !== null && _templateQueryParams$ !== void 0 ? _templateQueryParams$ : null;
  }
  var getLocation = function getLocation() {
    return location;
  };
  function formatNumber(settings) {
    return makeServiceGetRequestAsync('FormsViewer/FormatNumber', settings);
  }
  function formatDate(settings) {
    return makeServiceGetRequestAsync('FormsViewer/FormatDate', settings);
  }
  function getTemplateDefinitionAsync(includeTemplateXml, instanceId) {
    var params = _objectSpread({
      includeTemplateXml: includeTemplateXml
    }, instanceId ? {
      instanceId: instanceId
    } : null);
    return makeServiceGetRequestAsyncInternal('Forms/TemplateDefinition', params, !!instanceId // cache only if we have instance id
    );
  }
  function encrypt(settings) {
    return makeServicePostRequestAsync('FormsViewer/Encrypt', settings);
  }
  function decrypt(settings) {
    return makeServicePostRequestAsync('FormsViewer/Decrypt', settings);
  }
  function executeAdoAdapterAsync(connectionString, commandText, detectName, parameters) {
    return makeServicePostRequestAsync('WebProxy/ExecuteAdoAdapter', {
      connectionString: connectionString,
      commandText: commandText,
      detectName: detectName,
      parameters: parameters
    });
  }
  function getTemplateInfoAsync(options) {
    var safeOptions = options || {};
    var params = currentTemplateLocationType === _templateLocationTypes.LOCATION_TYPE_TEMPLATE_NAME || safeOptions.templateName ? {
      templateName: safeOptions.templateName || getTemplateLocation()
    } : {
      xsnUrl: getTemplateLocation()
    };
    var allParams = Object.assign({}, params, {
      countUsage: !!safeOptions.countUsage
    });
    return makeServicePostRequestAsync('Forms/GetTemplateInfo', allParams);
  }

  // 2018-06-27 - Removed unused getFileFromTemplateAsync()

  function getTemplatesAsync() {
    return makeServiceGetRequestAsyncInternal('FormsViewer/GetTemplateList');
  }
  function insertMappingAndUploadAsync(templateName, mappingName, mappingXmlString, addNew) {
    return makeServicePostRequestAsync('FormsViewer/InsertMappingAndUploadAsync', {
      templateName: templateName,
      mappingName: mappingName,
      mappingXmlString: mappingXmlString,
      addNew: addNew
    });
  }
  function injectQdabraRulesAsync(templateName) {
    return makeServicePostRequestAsync('FormsViewer/InjectQdabraRulesAsync', {
      templateName: templateName
    });
  }
  function generatePdfAsync(xml, viewNames, templateName, header, footer) {
    var params = _objectSpread({
      viewNames: viewNames,
      xml: xml,
      header: header,
      footer: footer
    }, templateName ? _defineProperty({}, PARAM_TEMPLATE_NAME, templateName) : templateQueryParams);
    return makeServicePostRequestAsync('Forms/GeneratePdf', params);
  }

  // (String, String, { updateFiles, deleteFiles, incrementVersion }) -> UpdateTemplateResult
  function updateTemplateAsync(templateName, instanceId, options) {
    return makeServicePostRequestAsync('FormsViewer/UpdateTemplate', _objectSpread({
      templateName: templateName,
      instanceId: instanceId
    }, options));
  }

  /* UploadTemplateSettings is 
  
     {
         formName: String,
         groupName: String,
         source: String,
         allowAnonymous: Boolean,
         file: Blob,
         fileName: String,
         queryMode?: String,
         update?: Boolean,
         allowDowngrade?: Boolean,
     }
   */
  // UploadTemplateSettings -> { message: String }
  var uploadTemplate = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref3) {
      var file, fileName, settings, result, Success, Message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            file = _ref3.file, fileName = _ref3.fileName, settings = _objectWithoutProperties(_ref3, _excluded);
            _context.next = 3;
            return makeServicePostRequestAsync('FormsViewer/UploadTemplateData', _objectSpread({
              allowDowngrade: false,
              update: false,
              queryMode: 'server',
              file: {
                blob: file,
                name: fileName
              }
            }, settings), {
              type: _qfsAccessBase.REQUEST_TYPE_FORM
            });
          case 3:
            result = _context.sent;
            Success = result.Success, Message = result.Message;
            if (Success) {
              _context.next = 7;
              break;
            }
            throw new Error(Message);
          case 7:
            return _context.abrupt("return", {
              message: Message
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function uploadTemplate(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  // { source: String, description: String, error: Error }
  var reportClientErrorAsync = function reportClientErrorAsync(_ref5) {
    var error = _ref5.error,
      rest = _objectWithoutProperties(_ref5, _excluded2);
    return makeServicePostRequestAsync('FormsViewer/ReportClientError', _objectSpread(_objectSpread({}, rest), (0, _errorHelpers.errorToObject)(error)));
  };
  function uploadNetworkFileAsync(createDirectory, fileName, fileString, overwrite, path) {
    return makeServicePostRequestAsync('LocalProxy/UploadNetworkFile', {
      createDirectory: createDirectory,
      fileName: fileName,
      fileString: fileString,
      overwrite: overwrite,
      path: path
    });
  }
  function listDirectoryAsync(path, mode) {
    return makeServicePostRequestAsync('LocalProxy/ListDirectory', {
      path: path,
      mode: mode
    });
  }
  function deleteNetworkFileAsync(path) {
    return makeServicePostRequestAsync('LocalProxy/DeleteFile', {
      path: path
    });
  }
  function localNetworkUsageCheckAsync(path) {
    return makeServiceGetRequestAsyncInternal('LocalProxy/UsageCheck', {
      path: path
    });
  }

  // TODO: Eliminate jquery from here
  function getStaticFileAsync(url) {
    return getTextAsync(url, null, true /* cache */);
  }

  // String -> Promise[String]
  var getNetworkFileText = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(path) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", callHelperGet('LocalProxy/GetFileText', {
              path: path
            }, false /* cache */));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getNetworkFileText(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();
  var internalRateOfReturn = function internalRateOfReturn(settings) {
    return callHelperGet('Calculation/InternalRateOfReturn', settings);
  };
  var netPresentValue = function netPresentValue(settings) {
    return callHelperGet('Calculation/NetPresentValue', settings);
  };

  // interface
  return {
    getAccessType: getAccessType,
    getTemplateLocation: getTemplateLocation,
    getLocation: getLocation,
    setAccessType: setAccessType,
    decrypt: decrypt,
    encrypt: encrypt,
    callCrossDomainRequestAsync: callCrossDomainRequestAsync,
    deleteNetworkFileAsync: deleteNetworkFileAsync,
    executeAdoAdapterAsync: executeAdoAdapterAsync,
    getTemplateInfoAsync: getTemplateInfoAsync,
    formatDate: formatDate,
    formatNumber: formatNumber,
    generatePdfAsync: generatePdfAsync,
    getStaticFileAsync: getStaticFileAsync,
    getImagePrefix: getImagePrefix,
    getTemplateFileAsync: getTemplateFileAsync,
    getTemplateDefinitionAsync: getTemplateDefinitionAsync,
    getTemplatesAsync: getTemplatesAsync,
    getXmlAsync: getXmlAsync,
    injectQdabraRulesAsync: injectQdabraRulesAsync,
    insertMappingAndUploadAsync: insertMappingAndUploadAsync,
    internalRateOfReturn: internalRateOfReturn,
    listDirectoryAsync: listDirectoryAsync,
    localNetworkUsageCheckAsync: localNetworkUsageCheckAsync,
    netPresentValue: netPresentValue,
    newGuidAsync: newGuidAsync,
    queryDirectSoapAsync: queryDirectSoapAsync,
    querySoapAsync: querySoapAsync,
    reportClientErrorAsync: reportClientErrorAsync,
    requestViewAsync: requestViewAsync,
    uploadTemplate: uploadTemplate,
    updateTemplateAsync: updateTemplateAsync,
    uploadNetworkFileAsync: uploadNetworkFileAsync,
    getNetworkFileText: getNetworkFileText
  };
}
var _default = exports["default"] = qfsAccess;